import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { NAMESPACES } from '~/i18n/namespaces';
import { usePublishedTemplateViewHeader } from '~/components/ClientExperience/OneFlow/components/FlowView/usePublishedTemplateViewHeader';
import { useCXRootStore } from '~/components/ClientExperience/stores/cx-root-store.provider';
import useAnalytics from '~/common/useAnalytics';
import NonUsaOrCanadaWarningModal from '~/common/NonUsaOrCanadaWarningModal';

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

const InternationalAvailabilityModal = ({ isOpen, onClose }: Props) => {
    const { track } = useAnalytics();
    const {
        flowStore: { flow }
    } = useCXRootStore();

    const { clickUseTemplate } = usePublishedTemplateViewHeader({ flow });

    const { t } = useTranslation(NAMESPACES.CLIENT_EXPERIENCE, {
        keyPrefix: 'public_template.international_modal'
    });

    const trackEvent = (user_choice: string) => {
        track('us/canada modal in public template', {
            action: 'click',
            user_choice: user_choice
        });
    };

    const closeModal = () => {
        trackEvent(t('not_based_cta'));
        onClose();
    };

    useEffect(() => {
        if (isOpen) {
            track('us/canada modal in public template', {
                action: 'load'
            });
        }
    }, [isOpen, track]);

    const onConfirm = () => {
        trackEvent(t('is_based_cta'));
        clickUseTemplate();
    };

    return (
        <NonUsaOrCanadaWarningModal
            isOpen={isOpen}
            onClose={closeModal}
            onConfirm={onConfirm}
        />
    );
};

export default observer(InternationalAvailabilityModal);
